import { ISupplierCountry } from "../types/data.interface";

export const formatSupplierCountryIntoOption = (item: ISupplierCountry) => ({
  value: item,
  label: `${item.name}, ${item.full_name}`,
});

export const getSupplierCountries = (supplierCountries: ISupplierCountry[]) =>
  supplierCountries.map(formatSupplierCountryIntoOption);
